var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 17h-2c-.5527344 0-1 .4472656-1 1v12h4v-12c0-.5527344-.4472656-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 23h-1c-.5527344 0-1 .4472656-1 1v6h3v-6c0-.5527344-.4472656-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 26h-1c-.5527344 0-1 .4472656-1 1v3h3v-3c0-.5527344-.4472656-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 20h-1c-.5527344 0-1 .4472656-1 1v9h3v-9c0-.5527344-.4472656-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 23h-1c-.5527344 0-1 .4472656-1 1v6h3v-6c0-.5527344-.4472656-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 5c-6.0654297 0-11 4.9345703-11 11h8c0-1.6542969 1.3457031-3 3-3 .4307251 0 .8383789.0949707 1.2089844.2590942l4.9707642-4.142334c.1992188-.1660156.4921875-.1542969.6738281.0302734.1826172.1826172.1962891.4746094.0302734.6738281l-4.1424561 4.9709473c.1639405.3703614.258606.7777711.258606 1.208191h8c0-6.0654297-4.9345703-11-11-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.8815308 7.163269c2.0250854-1.8672485 4.6871338-3.0428467 7.6235352-3.1635132-.0004884-.008789-.005066-.0161743-.005066-.0250854v-1.9746704c-3.4817505.1238403-6.6378174 1.5198364-9.0245361 3.743103l1.3780518 1.3780518c.0124511.0124512.0171508.0287475.0280151.0421142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.1464844 7.1211548 1.3780518-1.3780518c-2.3867188-2.2232666-5.5427857-3.6192627-9.0245362-3.743103v1.9746704c0 .0089111-.0045776.0162964-.0050659.0250854 2.9364014.1206665 5.5984497 1.2962646 7.6235352 3.1635132.0108642-.0133667.0155639-.029663.0280151-.0421142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.1464844 7.8535156-1.3780518-1.3780517c-2.3301391 2.5014038-3.7684326 5.8442993-3.7684326 9.5245361h2c0-3.1325073 1.2161255-5.9793091 3.1885986-8.1184692-.0133667-.0108643-.0296631-.015564-.0421142-.0280152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2315674 6.4754639-1.3780518 1.3780518c-.0124512.0124512-.0287476.0171509-.0421143.0280151 1.9724732 2.1391601 3.1885987 4.9859619 3.1885987 8.1184692h2c0-3.6802368-1.4382935-7.0231323-3.7684326-9.5245361z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.8ffe7e57f962fd1ba82f5bb6119547f6.svg";
export { ForwardRef as ReactComponent };